/** @jsx jsx */
import React, { useContext, useState, useEffect, useCallback } from 'react'
import { jsx } from '@emotion/core'
import MonthlyPerfDataContext from './MonthlyPerfDataContext'
import { saveMonthlyPerfMeterData } from 'api/pgads'
// eslint-disable-next-line no-unused-vars
import { Button, message, InputNumber, Steps, Divider, Modal } from 'antd'

import { ErrorContext, SpinContext } from 'context'
import { Content, FullHeightSizer } from 'core/screen-util'
import styled from '@emotion/styled'
import R from 'ramda'

const Th = styled.th`
  border: 0px solid grey;
  width: 100px;
`
const Td = styled.th`
  border: 2px solid white;
  width: 100px;
`
const Tr = styled.tr`
  height: 30px;
  padding: 1px;
  border: 5px solid white;
`
const Label = styled.div`
  display: grid;
  justify-content: end;
  padding-right: 30px;
`
const SharedMeter = props => {
  const { date, apiTargetInfo, hasWritePermission } = props
  const { setError } = useContext(ErrorContext)
  const { meterData, setDataError, md, setMd, revertMDData } = useContext(
    MonthlyPerfDataContext
  )
  // const { setDataError } = useContext(MonthlyPerfDataContext)
  // const meterData = props.meterData
  const { setSpinning } = useContext(SpinContext)
  const [currentStep, setCurrentStep] = useState(0)
  const errorMessageList = [
    'Data is not Valid',
    'Cannot Save. Unit 2 Start should be equal to Unit 1 End, in CT-4.',
    'Cannot Save. Unit 3 Start should be equal to Unit 2 End, in CT-4.',
    'Cannot Save. Unit 2 Start should be equal to Unit 1 End, in CT-5.',
    'Cannot Save. Unit 3 Start should be equal to Unit 2 End, in CT-5.',
    'Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 1.',
    'Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 2.',
    'Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 3.',
    'All Data Valid , Please Save',
  ]

  //= useMemo(
  //  //  _ =>
  //     (meterData || [])
  //       .filter(f => f.meterId.endsWith('SHARE'))
  //       .map(m => ({ [m.unit + m.unitName]: m }))
  //       .reduce((a, b) => ({ ...a, ...b }), {})
  //   [meterData]
  // )

  const stationData = (meterData || [])
    .filter(f => !(f.meterId || '').endsWith('SHARE'))
    .map(m => ({ [m.meterId]: m }))
    .reduce((a, b) => ({ ...a, ...b }), {})

  // const [md, setMd] = useState({ ...data })

  // useEffect(_ => setMd(data), [data])
  const onRevertData = _ => {
    // setMeterData(allData.meterDetails || [])
    // setMd(data)
    revertMDData()
  }

  const getMinDataValue = ({ type, key }) => {
    try {
      const val = R.min(
        def0Value(md['201' + type][key]),
        R.min(
          def0Value(md['202' + type][key]),
          def0Value(md['203' + type][key])
        )
      )
      return val
    } catch (err) {
      setCurrentStep(0)
      return 0
    }
  }

  const onSave = _ => {
    try {
      if (currentStep !== 8) {
        Modal.error({
          title: 'Error',
          content: errorMessageList[currentStep],
        })
        // message.error(errorMessageList[currentStep])
        return
      }

      const ct4201 = { ...(md['201CT-4'] || {}), unitName: 'Oconee 1' }
      const ct4202 = { ...(md['202CT-4'] || {}), unitName: 'Oconee 2' }
      const ct4203 = { ...(md['203CT-4'] || {}), unitName: 'Oconee 3' }
      const ct4MinStart = getMinDataValue({ type: 'CT-4', key: 'startRead' })
      const ct4MinEnd = getMinDataValue({ type: 'CT-4', key: 'endRead' })
      const ct4total = {
        ...md['201CT-5'],
        unitName: 'TOTAL',
        unit: 'TOT',
        utility: 'TOT',
        startRead: ct4MinStart,
        endRead: ct4MinEnd,
      }

      const ct5201 = { ...(md['201CT-5'] || {}), unitName: 'Oconee 1' }
      const ct5202 = { ...(md['202CT-5'] || {}), unitName: 'Oconee 2' }
      const ct5203 = { ...(md['203CT-5'] || {}), unitName: 'Oconee 3' }
      const ct5MinStart = getMinDataValue({ type: 'CT-5', key: 'startRead' })
      const ct5MinEnd = getMinDataValue({ type: 'CT-5', key: 'endRead' })
      const ct5total = {
        ...md['201CT-5'],
        unitName: 'TOTAL',
        unit: 'TOT',
        utility: 'TOT',
        startRead: ct5MinStart,
        endRead: ct5MinEnd,
      }

      const oea201 = {
        ...(md['201OCONEE 1 DOE SHARE'] || {}),
        unitName: 'Oconee 1',
      }
      const oea202 = {
        ...(md['202OCONEE 2 DOE SHARE'] || {}),
        unitName: 'Oconee 2',
      }
      const oea203 = {
        ...(md['203OCONEE 3 DOE SHARE'] || {}),
        unitName: 'Oconee 3',
      }
      // const oeaMinStart = getMinDataValue({type:'CT-5',key:'startRead'})
      // const oeaMinEnd = getMinDataValue({type:'CT-5',key:'endRead'})
      const oeatotal = {
        ...md['201OCONEE 1 DOE SHARE'],
        unitName: 'TOTAL',
        unit: 'TOT',
        utility: 'TOT',
        startRead: 0,
        endRead: 0,
      }
      setSpinning(true)
      const data = [
        ct4201,
        ct4202,
        ct4203,
        ct4total,
        ct5201,
        ct5202,
        ct5203,
        ct5total,
        oea201,
        oea202,
        oea203,
        oeatotal,
      ].map(a => ({ ...a, action: 'N' }))
      saveMonthlyPerfMeterData(apiTargetInfo)(data, date).fork(
        setError,
        data => {
          setSpinning(false)
          if (data.length === 0) {
            message.info('Saved Oconee Successfully')
          } else setDataError(data)
        }
      )
    } catch (err) {
      setCurrentStep(0)
      return 0
    }
  }

  const isNanValue = val => (isNaN(val) ? 0 : val)

  const def0Value = useCallback(val => {
    try {
      const v = parseInt(val)
      return isNanValue(v)
    } catch (e) {
      return 0
    }
  }, [])

  useEffect(
    _ => {
      try {
        const ct4201start = def0Value(md['201CT-4'].startRead)
        const ct4201end = def0Value(md['201CT-4'].endRead)
        const ct4202start = def0Value(md['202CT-4'].startRead)
        const ct4202end = def0Value(md['202CT-4'].endRead)
        const ct4203start = def0Value(md['203CT-4'].startRead)
        const ct4203end = def0Value(md['203CT-4'].endRead)

        const ct5201start = def0Value(md['201CT-5'].startRead)
        const ct5201end = def0Value(md['201CT-5'].endRead)
        const ct5202start = def0Value(md['202CT-5'].startRead)
        const ct5202end = def0Value(md['202CT-5'].endRead)
        const ct5203start = def0Value(md['203CT-5'].startRead)
        const ct5203end = def0Value(md['203CT-5'].endRead)

        const oae201start = def0Value(md['201OCONEE 1 DOE SHARE'].startRead)
        const oae201end = def0Value(md['201OCONEE 1 DOE SHARE'].endRead)
        const oae202start = def0Value(md['202OCONEE 2 DOE SHARE'].startRead)
        const oae202end = def0Value(md['202OCONEE 2 DOE SHARE'].endRead)
        const oae203Start = def0Value(md['203OCONEE 3 DOE SHARE'].startRead)
        const oae203end = def0Value(md['203OCONEE 3 DOE SHARE'].endRead)

        const ct4201total = isNanValue(ct4201end) - isNanValue(ct4201start)
        const ct5201total = isNanValue(ct5201end) - isNanValue(ct5201start)
        const oae201total = isNanValue(oae201start) + isNanValue(oae201end)

        const ct4202total = isNanValue(ct4202end) - isNanValue(ct4202start)
        const ct5202total = isNanValue(ct5202end) - isNanValue(ct5202start)
        const oae202total = isNanValue(oae202start) + isNanValue(oae202end)

        const ct4203total = isNanValue(ct4203end) - isNanValue(ct4203start)
        const ct5203total = isNanValue(ct5203end) - isNanValue(ct5203start)
        const oae203total = isNanValue(oae203Start) + isNanValue(oae203end)

        if (ct4202start !== ct4201end) setCurrentStep(1)
        else if (ct4203start !== ct4202end) setCurrentStep(2)
        else if (ct5202start !== ct5201end) setCurrentStep(3)
        else if (ct5203start !== ct5202end) setCurrentStep(4)
        else if (ct4201total + ct5201total !== oae201total) setCurrentStep(5)
        else if (ct4202total + ct5202total !== oae202total) setCurrentStep(6)
        else if (ct4203total + ct5203total !== oae203total) setCurrentStep(7)
        else setCurrentStep(8)
      } catch (err) {
        setCurrentStep(0)
      }
    },
    [def0Value, md, setCurrentStep, setMd]
  )

  // mapkey=m.unit +  m.unitName
  const onChange = ({ mapKey, key }) => value =>
    setMd({
      ...md,
      [mapKey]: {
        ...md[mapKey],
        [key]: def0Value(value),
      },
    })
  const numberStyle = { width: 'auto' }

  const getEmptyComp = _ => {
    return <InputNumber disabled precision={0} style={numberStyle} />
  }

  const getNumberField = ({
    disabled = false,
    key,
    valObj = {},
    isStation = false,
  }) => {
    if (valObj === undefined) return getEmptyComp()
    if (isStation)
      return <InputNumber value={valObj[key]} disabled style={numberStyle} />
    return (
      <InputNumber
        onChange={onChange({ mapKey: valObj.unit + valObj.unitName, key })}
        value={valObj.unit ? md[valObj.unit + valObj.unitName][key] : 0}
        disabled={disabled || !hasWritePermission}
        precision={0}
        style={numberStyle}
      />
    )
  }
  const getReadOnlyField = ({ mapKey, sign = '-' }) => {
    const valObj = md[mapKey] || {}
    let val = 0
    try {
      val =
        sign === '-'
          ? def0Value(valObj.endRead) - def0Value(valObj.startRead)
          : def0Value(valObj.endRead) + def0Value(valObj.startRead)
    } catch (err) {
      setCurrentStep(0)
    }
    return (
      <InputNumber
        disabled
        value={def0Value(val)}
        precision={0}
        style={numberStyle}
      />
    )
  }

  const getMinValue = ({ type, key }) => {
    const val = getMinDataValue({ type, key })
    return (
      <InputNumber
        value={def0Value(val)}
        disabled
        precision={0}
        style={numberStyle}
      />
    )
  }

  const getMinTotal = ({ type }) => {
    const val =
      getMinDataValue({ type, key: 'endRead' }) -
      getMinDataValue({ type, key: 'startRead' })
    return (
      <InputNumber
        value={def0Value(val)}
        disabled
        precision={0}
        style={numberStyle}
      />
    )
  }

  const getDOETatal = _ => {
    try {
      let sttart201 =
        def0Value((md['201OCONEE 1 DOE SHARE'] || {}).startRead) +
        def0Value((md['201OCONEE 1 DOE SHARE'] || {}).endRead)

      sttart201 = isNanValue(sttart201)

      let sttart202 =
        def0Value((md['202OCONEE 2 DOE SHARE'] || {}).startRead) +
        def0Value((md['202OCONEE 2 DOE SHARE'] || {}).endRead)

      sttart202 = isNanValue(sttart202)

      let sttart203 =
        def0Value((md['203OCONEE 3 DOE SHARE'] || {}).startRead) +
        def0Value((md['203OCONEE 3 DOE SHARE'] || {}).endRead)

      sttart203 = isNanValue(sttart203)

      return (
        <InputNumber
          disabled
          value={parseInt(sttart201 + sttart202 + sttart203)}
          precision={0}
          style={numberStyle}
        />
      )
    } catch (err) {
      setCurrentStep(0)
      return (
        <InputNumber disabled value={0} precision={0} style={numberStyle} />
      )
    }
  }

  return (
    <FullHeightSizer heightOffset={280}>
      {({ height }) => (
        <Content
          css={{ height: height - 20, paddingTop: '10px', margin: '0px' }}
        >
          {meterData.length <= 0 && (
            <div style={{ display: 'grid', justifyContent: 'center' }}>
              <h1>
                No data exists for CT4 and CT 5.
                <br />
                Please select another month/year.
              </h1>
            </div>
          )}
          {meterData.length > 0 && (
            <div
              style={{ display: 'grid', gridTemplateRows: 'auto auto auto' }}
            >
              {hasWritePermission && (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '150px 150px 600px',
                    gridColumnGap: '10px',
                    margin: '5px',
                  }}
                >
                  <Button
                    // disabled={currentStep !== 8}
                    onClick={onSave}
                    type="primary"
                    icon="edit"
                  >
                    Save
                  </Button>
                  <Button
                    type="danger"
                    onClick={onRevertData}
                    disabled={!hasWritePermission}
                  >
                    Revert Changes
                  </Button>
                  <div
                    style={{
                      display: 'grid',
                      justifyContent: 'center',
                      // alignContent: 'center',
                      alignContent: 'baseline',
                    }}
                  >
                    {errorMessageList[currentStep]}
                  </div>
                </div>
              )}
              {hasWritePermission && <Divider style={{ margin: '0px' }} />}
              <div
                style={{
                  display: 'grid',
                  gridTemplateRows: 'auto',
                  gridTemplateColumns: '12fr',
                  // gridGap: '20px',
                  overflowY: 'auto',
                  height: height - 100 + 'px',
                  width: '800px',
                  maxWidth: '900px',
                }}
              >
                <table>
                  <thead>
                    <Tr>
                      <Th css={{ width: '130px' }}>
                        <Label>Meter</Label>
                      </Th>
                      <Th css={{ width: '150px' }} />
                      <Th>Station</Th>
                      <Th>Unit 1</Th>
                      <Th>Unit 2</Th>
                      <Th>Unit 3</Th>
                      <Th>Total</Th>
                    </Tr>
                  </thead>
                  <tbody>
                    <Tr>
                      <Td>
                        <Label>CT-4</Label>
                      </Td>
                      <Td>
                        <div style={{ minWidth: '150px' }}>
                          <Label>Start</Label>
                        </div>
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: stationData['OCNE-1_CT-4'],
                          disabled: true,
                          isStation: true,
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['201CT-4'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['202CT-4'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['203CT-4'],
                        })}
                      </Td>
                      <Td>{getMinValue({ type: 'CT-4', key: 'startRead' })}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>End</Label>
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: stationData['OCNE-1_CT-4'],
                          disabled: true,
                          isStation: true,
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['201CT-4'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['202CT-4'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['203CT-4'],
                        })}
                      </Td>
                      <Td>{getMinValue({ type: 'CT-4', key: 'endRead' })}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>Usage</Label>
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                      <Td>{getReadOnlyField({ mapKey: '201CT-4' })}</Td>
                      <Td>{getReadOnlyField({ mapKey: '202CT-4' })}</Td>
                      <Td>{getReadOnlyField({ mapKey: '203CT-4' })}</Td>
                      <Td>{getMinTotal({ type: 'CT-4' })}</Td>
                    </Tr>
                    <Tr css={{ height: '2px' }}>
                      <td colSpan={7}>
                        <Divider style={{ margin: '0px' }} />
                      </td>
                    </Tr>
                    <Tr>
                      <Td>
                        <Label>CT-5</Label>
                      </Td>
                      <Td>
                        <Label>Start</Label>
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: stationData['OCNE-1_CT-5'],
                          disabled: true,
                          isStation: true,
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['201CT-5'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['202CT-5'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['203CT-5'],
                        })}
                      </Td>
                      <Td>{getMinValue({ type: 'CT-5', key: 'startRead' })}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>End</Label>
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: stationData['OCNE-1_CT-5'],
                          disabled: true,
                          isStation: true,
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['201CT-5'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['202CT-5'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['203CT-5'],
                        })}
                      </Td>
                      <Td>{getMinValue({ type: 'CT-5', key: 'endRead' })}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>Usage</Label>
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                      <Td>{getReadOnlyField({ mapKey: '201CT-5' })}</Td>
                      <Td>{getReadOnlyField({ mapKey: '202CT-5' })}</Td>
                      <Td>{getReadOnlyField({ mapKey: '203CT-5' })}</Td>
                      <Td>{getMinTotal({ type: 'CT-5' })}</Td>
                    </Tr>
                    <Tr css={{ height: '2px' }}>
                      <td colSpan={7}>
                        <Divider style={{ margin: '0px' }} />
                      </td>
                    </Tr>
                    <Tr>
                      <Td>DOE Aux On/Off</Td>
                      <Td>
                        <Label>Online Auxiliary</Label>
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['201OCONEE 1 DOE SHARE'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['202OCONEE 2 DOE SHARE'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'startRead',
                          valObj: md['203OCONEE 3 DOE SHARE'],
                        })}
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>Offline Auxiliary</Label>
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['201OCONEE 1 DOE SHARE'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['202OCONEE 2 DOE SHARE'],
                        })}
                      </Td>
                      <Td>
                        {getNumberField({
                          key: 'endRead',
                          valObj: md['203OCONEE 3 DOE SHARE'],
                        })}
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                    </Tr>
                    <Tr>
                      <Td />
                      <Td>
                        <Label>Total</Label>
                      </Td>
                      <Td>{getEmptyComp()}</Td>
                      <Td>
                        {getReadOnlyField({
                          mapKey: '201OCONEE 1 DOE SHARE',
                          sign: '+',
                        })}
                      </Td>
                      <Td>
                        {getReadOnlyField({
                          mapKey: '202OCONEE 2 DOE SHARE',
                          sign: '+',
                        })}
                      </Td>
                      <Td>
                        {getReadOnlyField({
                          mapKey: '203OCONEE 3 DOE SHARE',
                          sign: '+',
                        })}
                      </Td>
                      <Td>{getDOETatal()}</Td>
                    </Tr>
                    <Tr />
                  </tbody>
                </table>

                {/* <div>
                <Steps direction="vertical" current={currentStep} size="small">
                  <Steps.Step title="Data is not Valid" />
                  <Steps.Step
                    // title="CT-4 , Unit 2 ,Start Data not Matched"
                    title="Cannot Save. Unit 2 Start should be equal to Unit 1 End, in CT-4."
                  />
                  <Steps.Step
                    // title="CT-4,Unit 3 ,Start Data not Matched"
                    title="Cannot Save. Unit 3 Start should be equal to Unit 2 End, in CT-4."
                  />
                  <Steps.Step
                    // title="CT-5 , Unit 2 ,Start Data not Matched"
                    title="Cannot Save. Unit 2 Start should be equal to Unit 1 End, in CT-5."
                  />
                  <Steps.Step
                    // title="CT-5,Unit 3,Start Data not Matched"
                    title="Cannot Save. Unit 3 Start should be equal to Unit 2 End, in CT-5."
                  />
                  <Steps.Step
                    // title="Unit 1 , CT-4-Usage + CT-5-Usage  =  DOE Aux total, Data not Matched"
                    title="Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 1."
                  />
                  <Steps.Step
                    // title="Unit 2 , CT-4-Usage + CT-5-Usage  =  DOE Aux total, Data not Matched"
                    title="Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 2."
                  />
                  <Steps.Step
                    // title="Unit 3 , CT-4-Usage + CT-5-Usage  =  DOE Aux total, Data not Matched"
                    title="Cannot Save. Sum of the usages should equal the DOE Aux total, in Unit 3."
                  />
                  <Steps.Step
                    // title="Unit 3 , CT-4-Usage + CT-5-Usage  =  DOE Aux total, Data not Matched"
                    title="All Data Valid , Please Save"
                  />
                </Steps>
              </div> */}
              </div>
            </div>
          )}
        </Content>
      )}
    </FullHeightSizer>
  )
}

export default SharedMeter
